<template>
	<transition name="modal">
		<div class="modal-mask" v-show="show">
			<div class="modal-container">
				<div class="modal-header">
					<h3>Bloquear Atendimentos de Subgrupo por Período</h3>
				</div>
				<div class="modal-body">
					<div class="row">
						<div class="col-sm-12">
							<label>Filtros: </label>
						</div>
						<div class="col-md-9">
							<div class="form-group">
								<select-subgrupo :contrato-id="$route.params.distribuicaoContratoId"
								placeholder="SUBGRUPO" @setSubgrupoSelecionado="(subgrupoSelecionado)=>{setSubgrupoSelecionado(subgrupoSelecionado)}"></select-subgrupo>
							</div>
						</div>
						<div class="col-md-3">
							<div class="form-group">
								<select v-model="filtros.sexo" class="form-control">
									<option :value="SEXO.AMBOS">AMBOS</option>
									<option :value="SEXO.MASCULINO">MASCULINO</option>
									<option :value="SEXO.FEMININO">FEMININO</option>
								</select>
							</div>
						</div>
						<div class="col-md-6">
							<div :class="{'form-group': true, 'has-error':errors.has('periodo_de') }">
								<label>Período (De)</label>
								<input
									v-model="filtros.data_inicial"
									class="form-control"
									type="date"
									placeholder="PERÍODO DE"
									v-validate="'required'"
									name="periodo_de"
									ref="periodo_de"
								>
								<span v-show="errors.has('periodo_de')" class="help-block">{{ errors.first('periodo_de') }}</span>
							</div>
						</div>

						<div class="col-md-6">
							<div :class="{'form-group': true, 'has-error':errors.has('periodo_ate') }">
								<label>Período (Até)</label>
								<input
									v-model="filtros.data_final"
									class="form-control"
									type="date"
									placeholder="PERÍODO DE"
									v-validate="'required'"
									name="periodo_ate"
									ref="periodo_ate"
								>
								<span v-show="errors.has('periodo_ate')" class="help-block">{{ errors.first('periodo_ate') }}</span>
							</div>
						</div>
						<div class="col-md-6">
							<div :class="{'form-group': true, 'has-error':errors.has('atendimento') }">
								<label for="">Atendimentos bloqueados</label>
								<input
									type="number"
									min="0"
									class="form-control"
									v-model.number="dados.quantidade_atendimento_bloqueada"
									v-validate="dados.quantidade_local_bloqueada === '' ?'required' : ''"
									name="atendimento"
									ref="atendimento"
								>
								<span v-show="errors.has('atendimento')" class="help-block">Defina ao menos um bloqueio</span>
							</div>
						</div>
						<div class="col-md-6">
							<div :class="{'form-group': true, 'has-error':errors.has('local') }">
								<label for="">Locais bloqueados</label>
								<input
									type="number"
									min="0"
									class="form-control"
									v-model.number="dados.quantidade_local_bloqueada"
									v-validate="dados.quantidade_atendimento_bloqueada === '' ?'required' : ''"
									name="local"
									ref="local"
								>
								<span v-show="errors.has('local')" class="help-block">Defina ao menos um bloqueio</span>
							</div>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<div class="row">
						<div class="col-md-12">
							<button
								@click="salvar()"
								class="btn btn-primary pull-right"
								type="button"
							><i class="fa fa-save"></i> Confirmar</button>
							<button tag="a" @click="$emit('close')" class="btn btn-default pull-left"><i class="fa fa-close"></i> Cancelar</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
import axios from "axios"; // Cliente para requisição http
import { SEXO } from "@/constants";
import selectSubgrupo from "../contratos/selectDistribuicaoSubgruposContrato";

export default {
	filters: { },
	computed: {
		SEXO: function() {
			return SEXO;
		}
	},
	props: ["show", "distribuicao_contrato_id"],
	data: () => ({
        filtros: {
			distribuicao_contrato_id: null,
			nome_subgrupo: '',
			sexo: SEXO.AMBOS,
			tipo: 1,
			coluna: null,
			ordem: null,
			data_inicial: null,
			data_final: null
		},
		dataTable: { },
        bloqueados: {
            primeira: 0,
            local: 0,
        },
		dados: {
			quantidade_atendimento_bloqueada: "",
            quantidade_local_bloqueada: "",
        },
	}),
	mounted() {
		document.body.addEventListener('keyup', e => {
			if (e.keyCode === 27) {
				this.$emit('close');
			}
		})
	},
	methods: {
        salvar() {
			this.$validator.validateAll().then(result => {
				if (result) {
					this.$store.commit("TOGGLE_LOADING");
					let config = this.$store.getters.getHeaderAuth;
					this.dados.filtros = this.filtros;
					axios.post(
						`${this.$store.state.serverURI}/api/distribuicao/agenda/bloquearPeriodoSubgrupo`,
						this.dados,
						config
					).then(response => {
						this.$emit('atualizar');
						this.$emit('close');
						this.$store.commit("TOGGLE_LOADING");
					}).catch(error => {
						this.$store.commit("throwException", error);
					});
				}
			});
		},
		setSubgrupoSelecionado(subgrupoSelecionado) {
			this.filtros.nome_subgrupo = subgrupoSelecionado.subgrupo.nome;
		},
	},
	watch: {
		show: function(value, old) {
			if (value) {
				this.filtros.distribuicao_contrato_id = this.distribuicao_contrato_id;
			}
		}
	},
	components: {
		selectSubgrupo
	}
};
</script>

<style scoped>
* {
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// bloquearSubgruposPeriodoModal.vue?28b80831